<template>
  <div>
    <div class="wi-100x ht-100x pf lf-0 tp-0 z-1000" v-if="loading">
      <fo-loading @finishCallback="finishCallback"></fo-loading>
    </div>
    <fo-navmenu
      :iconColor="iconColor"
      :backColor="backColor"
      :textColor="textColor" />
    <fo-caseHead
      :subtitle="workInfo.work_subtitle"
      :intro="workInfo.work_tags"
      :title="workInfo.work_title" />
    <fo-profile :info="workInfo"/>
    <fo-context :content="contentList" />
    <fo-moreWorks />
    <fo-sayHello />
    <fo-bottom />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'casestudy',
  computed: {
    ...mapGetters([
      'scrollTop',
      'screenWidth',
      'screenHeight',
      'sloganInfo',
      'scrollHeight'
    ])
  },
  data () {
    return {
      loading: false,
      textColor: '',
      backColor: '',
      iconColor: '',
      workInfo: {},
      worksLittleTitle: '',
      contentList: []
    }
  },
  watch: {
    sloganInfo (val) {
      if (this.$.s2o(val).works_small_character) {
        this.worksLittleTitle = this.$.s2o(val).works_small_character
      }
    },
    scrollTop () {
      this.setColor()
    }
  },
  mounted () {
    if (window.performance.navigation.type === 1) {
      this.loading = true
    }
    if (this.sloganInfo && this.$.s2o(this.sloganInfo).works_small_character) {
      this.worksLittleTitle = this.$.s2o(this.sloganInfo).works_small_character
    }
    this.setColor()
    this.findWorkInfo()
  },
  methods: {
    finishCallback () {
      this.loading = false
      this.$store.commit('updateRefresh', false)
    },
    /*
    * 查询作品详情
    */
    findWorkInfo () {
      this.get({
        url: 'webWorksFind',
        data: {
          work_team_id: '6',
          id: this.$route.params.id
        }
      }, (r) => {
        if (r.code) {
          this.workInfo = r.data
          this.contentList = this.$.s2o(this.workInfo.work_content)
          if (r.data.work_subtitle) {
            document.getElementsByTagName('title')[0].innerText = 'GEOHE几合_' + r.data.work_subtitle
          }
          if (!r.data.work_content) {
            this.router('/works')
          }
        } else {
          this.router('/works')
        }
      })
    },
    setColor () {
      var bottomHeight = document.getElementById('bottom-compos').offsetHeight
      var appHeight = document.getElementById('app').offsetHeight
      let cond = appHeight - appHeight * this.scrollHeight * 0.01 - bottomHeight + this.screenHeight < 0
      if (cond) {
        this.textColor = 'white'
        this.backColor = 'white-bg'
        this.iconColor = 'black-bg'
      } else {
        this.textColor = 'black'
        this.backColor = 'black-bg'
        this.iconColor = 'white-bg'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Casestudy.vue